import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const confirmFileUploadAtom = createMutationAtomFactory(
  'customerPortal.confirmFileUpload',
  (input: { fileId: string }) => ({
    tradeFileConfirmUpload: {
      __args: {
        fileId: input.fileId,
      },
      id: true,
    },
  }),
);
